import { type EditMaterialTypeInputType } from '@shelflix/schemas/materialType/edit';
import { create } from 'zustand';

interface MaterialTypeFormStore {
  formData: Partial<EditMaterialTypeInputType>;
  setFormData: (data: Partial<EditMaterialTypeInputType>) => void;
  resetForm: () => void;
}

export const useMaterialTypeFormStore = create<MaterialTypeFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
